import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { latLng, tileLayer } from 'leaflet';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TripUploaderComponent } from '../modals/trip-uploader/trip-uploader.component';
import { TripInfoComponent } from '../modals/trip-info/trip-info.component';
import { TripDescribeComponent } from '../modals/trip-describe/trip-describe.component';
import { ConfirmSentComponent } from '../modals/confirm-sent/confirm-sent.component';
import { from, Observable, of, concat, Subject } from 'rxjs';
import { catchError, switchMap, distinctUntilChanged, tap, map } from 'rxjs/operators';
import { Transports, TansportUiModel } from './transport.ui.model';
import { Companions, CompanionUiModel } from './companion.ui.model';

import * as L from 'leaflet';
import 'leaflet-editable';
import 'leaflet.gridlayer.googlemutant';
import 'leaflet-routing-machine';
import { StreetViewService } from '../../services/street-view.service';
import { Route } from '../../models/segment';
import { UserService } from '../../services/user.service';
import { DataService } from '../../services/data.service';
import { Router, ActivatedRoute } from '@angular/router';
import { GeocodingService } from 'src/app/services/geocoding.service';
import { AppConfig } from 'src/app/app.config';
import { PreviousRouteService } from 'src/app/services/previous-router.service';

import _ from "lodash";
import { ErrorModalComponent } from '../modals/error-modal/error-modal.component';


@Component({
  selector: 'app-trip',
  templateUrl: './trip.component.html',
  styleUrls: ['./trip.component.scss']
})
export class TripComponent implements OnInit {
  public tripOptionShown: boolean = false;
  public leafletOptions: any;
  public leafletTripOptions: any;
  public layers: any[];

  public tiles = [];
  public currentTileIdx = 1;

  public isLoading = false;
  public actionText = "Inserting...";

  public transports: Array<TansportUiModel> = [];
  public transport: TansportUiModel;

  public companions: Array<CompanionUiModel> = [];
  public selectedCompanions: Array<CompanionUiModel>;
  public isPupil: boolean = false;

  private map: L.DrawMap;

  latlngs: L.LatLng[];
  from: string = 'web';

  oldLatlngs: L.LatLng[];

  address$: Observable<any[]>;
  addressLoading: boolean = false;
  addressInput$ = new Subject<string>();


  public data = [];
  public isLoaded = false;
  public pageSize = 10;
  public page = 1;

  constructor(
    private cd: ChangeDetectorRef,
    private modalService: NgbModal,
    private userService: UserService,
    private dataService: DataService,
    private route: Router,
    private gsv: StreetViewService,
    private activatedRoute: ActivatedRoute,
    private geocodingService: GeocodingService,
    private appConfig: AppConfig,
    private previousRouteService: PreviousRouteService
  ) {
  }

  ngOnInit() {
    this.transports = Transports.get();
    this.companions = Companions.get();
    this.userService.getUserInfo().subscribe(user => { this.isPupil = user.attributes.userType.includes('PUPIL') });
    this.userService.loginToProject(this.userService.project.projectID.id).subscribe(project => { });
    this.initPage();
    this.initTypeahead();
    this.initTrip();

    this.activatedRoute
      .queryParams
      .subscribe(params => {
        // Defaults to 0 if no query param provided.
        this.page = params['page'] || 1;
      });
  }

  initTrip() {
    this.transport = {
      id: 1,
      profile: 'foot',
      type: 'foot',
      img: 'assets/svg/transports/1.svg',
      transport: 'foots'
    };
    this.selectedCompanions = [];
    this.oldLatlngs = null;
  }

  initTypeahead() {
    const project_location = localStorage.getItem('project_location');
    this.address$ = concat(
      of([]),
      this.addressInput$.pipe(
        distinctUntilChanged(),
        tap(() => this.addressLoading = true),
        switchMap(term => {
          if (term) {
            console.log(this.map.getCenter());
            let latlng;
            if (!project_location) { latlng = this.map.getCenter(); }
            else {
              const locations = project_location.split(',');
              var latitude = parseFloat(locations[1]),
                longitude = parseFloat(locations[0]);
              latlng = L.latLng(latitude, longitude);
            }
            return this.geocodingService.addressAutocomplete(term, latlng.lat, latlng.lng).pipe(
              catchError(() => of([])),
              map(result => {
                if (result.features) return result.features.map(r => Object.assign(r.properties, r.geometry));
                else return [];
              }),
              tap(() => this.addressLoading = false)
            );
          }
          this.addressLoading = false;
          // return of([]).pipe(
          //   map(() => this.addressLoading = false)
          // );
        })
      )
    )
  }

  findPos(latlng) {
    this.map.panTo({ lng: latlng.lon ? latlng.lon : latlng.lng, lat: latlng.lat });
    this.map.setZoom(18);
  }

  onInputAddress(event) {
    console.log('input', event);
    if (event.coordinates) {
      const latlng = L.latLng(event.coordinates[1], event.coordinates[0]);
      this.findPos(latlng);
    }
    else if (event.name) {
      this.geocodingService.findPosition(event.name).subscribe(response => {
        if (response && response.lat) this.findPos(response);
      }, err => {
        const errDlg = this.modalService.open(ErrorModalComponent);
        errDlg.componentInstance.header = 'Unknown address';
        errDlg.componentInstance.message = 'The location of this address could not be determined. Please enter a new address.';
      });
    }
  }

  initPage() {
    const tileLayerOptions = {
      maxZoom: 18,
      id: 'mapbox.streets',
      accessToken: 'pk.eyJ1IjoiYW50b242Mzc4IiwiYSI6IlBtMG5pMjgifQ.bGiCZKEStTnO5YjSzmkJZg'
    };

    this.tiles = [
      // tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', tileLayerOptions),
      // @ts-ignore
      L.gridLayer.googleMutant({ type: 'satellite' }),
      this.appConfig.getTileLayer()
    ];

    this.leafletOptions = {
      layers: [
        this.tiles[1]
      ],
      zoom: 14,
      center: latLng(50.848656786354994, 4.349341392517091)
    };

    this.map = L.map('map', this.leafletOptions);

    const helpBtnClick = JSON.parse(localStorage.getItem('help-btn'));
    if (this.previousRouteService.getPreviousUrl() == '/help' && helpBtnClick) {
      localStorage.setItem('help-btn', JSON.stringify(false));
      this.addTrip();
    } else {
      this.tripOptionShown = false;
    }

    this.dataService.getISentRoute().subscribe(response => {
      this.data = response.sort((a, b) => (a.timeStamp > b.timeStamp) ? -1 : 1);
      this.isLoaded = true;

      this.isLoading = false;
    });
  }

  toggleMapType() {
    try {
      this.tiles[this.currentTileIdx].removeFrom(this.map);
    } catch { }
    // this.currentTileIdx = this.currentTileIdx == 2 ? 0 : this.currentTileIdx + 1;
    this.currentTileIdx = this.currentTileIdx == 1 ? 0 : this.currentTileIdx + 1;
    this.tiles[this.currentTileIdx].addTo(this.map);
  }

  sortBy(event, col) {

    let direct;
    if (event.currentTarget.classList.contains('asc')) {
      direct = 'desc';
      event.currentTarget.classList.add('desc');
      event.currentTarget.classList.remove('asc');
    }
    else {
      direct = 'asc';
      event.currentTarget.classList.remove('desc');
      event.currentTarget.classList.add('asc');
    }
    let direct_val;
    if (direct == 'asc') direct_val = 1;
    else direct_val = -1;
    if (col == 'date') this.data.sort((a, b) => (a.timeStamp > b.timeStamp) ? direct_val : -direct_val);
    if (col == 'transport') this.data.sort((a, b) => (a.genericAttributes.attributes.mode[0] > b.genericAttributes.attributes.mode[0]) ? direct_val : -direct_val);
    if (col == 'source') this.data.sort((a, b) => (a.genericAttributes.attributes['source_device'][0] > b.genericAttributes.attributes['source_device'][0]) ? direct_val : -direct_val);
  }

  refreshPage() {
    if (this.map) {
      this.map.remove();
    }
    this.initPage()
  }

  selectTransport(item) {
    this.transport = _.cloneDeep(item);
    this.refreshPage()
    this.addTrip()
  }

  selectCompanion(item) {
    const includesAlone = this.selectedCompanions.map(c => c.profile.toUpperCase()).includes('ALONE');
    const isAlone = item.profile.toUpperCase() === 'ALONE';

    if ((includesAlone && !isAlone) || (!includesAlone && isAlone)) {
      this.selectedCompanions = [item];
    } else {
      if (this.selectedCompanions.find((i) => i.id === item.id)) {
        this.selectedCompanions = this.selectedCompanions.filter(i => i.id !== item.id);
      } else {
        this.selectedCompanions = [...this.selectedCompanions, item];
      }
    }
  }

  isCompanionActive(type: string) {
    return this.selectedCompanions.map(c => c.type).includes(type);
  }

  addTrip() {
    this.tripOptionShown = true;
    let projectLocation = this.userService.project.project.projectData.location.coordinates;
    let userLocation = this.userService.user.attributes.location[0].coordinates;
    this.newRouting(
      this.oldLatlngs === null
        ? [new L.LatLng(userLocation[1], userLocation[0]), new L.LatLng(projectLocation[1], projectLocation[0])]
        : this.oldLatlngs,
    );
  }

  newRouting(latLngs: L.LatLng[]) {

    let plan = new L.Routing.Plan(latLngs, {
      createMarker: this.routeMarker.bind(this)
    });

    let routing: L.Routing.Control = new L.Routing.Control({
      autoRoute: false,
      show: false,
      plan: plan,
      routeLine: this.routeLine,
      lineOptions: {
        styles: [{ color: 'green', opacity: 1, weight: 4 }]
      },
      router: new L.Routing.OSRMv1({
        serviceUrl: this.appConfig.getOsrmServiceUrl() + this.transport.type + '/route/v1',
        routingOptions: {
          profile: this.transport.type
        }
      })
    });

    plan.on('waypointschanged', (e: L.LeafletEvent & L.Routing.RoutingEvent) => {
      this.oldLatlngs = e.waypoints.map(w => w.latLng);
      routing.route();
    });

    routing.addTo(this.map);

    routing.on('routesfound', e => {
      this.latlngs = e.routes[0].coordinates;
    });

    routing.route();

    return routing;
  }

  routeLine(route, options) {
    let line = L.Routing.line(route, options);
    let tooltip = L.tooltip({ sticky: true, direction: 'top' }).setContent('Drag to route');
    line.eachLayer(l => { l.bindTooltip(tooltip) });
    return line;
  }

  routeMarker(i, waypoint, n) {
    if (i == 0)
      return L.marker(waypoint.latLng, {
        icon: L.icon({ iconUrl: 'assets/marker/home.png', iconSize: [57, 67], iconAnchor: [27, 66] }),
        draggable: true
      }).bindTooltip(`${this.userService.user.attributes.address[0].street} ${this.userService.user.attributes.address[0].houseNumber}`);

    if (i == n - 1)
      return L.marker(waypoint.latLng, {
        icon: L.icon({ iconUrl: 'assets/marker/office.png', iconSize: [57, 67], iconAnchor: [27, 66] }),
        draggable: true
      });

    return L.marker(waypoint.latLng, { icon: L.icon({ iconUrl: 'assets/marker/dot.png', iconSize: [19, 19] }), draggable: true });
  }

  openTripLoader() {
    const options: NgbModalOptions = {
      backdrop: false,
      keyboard: false,
      size: 'xl',
      centered: true,
      windowClass: 'tripUploadModal'
    };
    const upperCase = (str) => {
      return str.toUpperCase()
    }
    this.openTripLoaderModal(options).subscribe(r => {
      if (r && r !== 'close') {
        this.isLoading = true;
        this.actionText = "Inserting...";
        localStorage.setItem('i_sent', JSON.stringify(true));
        this.dataService.routeSend(
          this.userService.project.projectID.id, 
          r,
          upperCase(this.transport.profile), 
          this.selectedCompanions.map(c => upperCase(c.profile)
        )).subscribe(e => {
          this.refreshPage();
        }, (err) => {
          this.refreshPage();
          const errDlg = this.modalService.open(ErrorModalComponent);
          errDlg.componentInstance.header = 'Error while inserting route';
          errDlg.componentInstance.message = err.error.error;
        });
      }
    });
  }

  openTripLoaderModal(modalOptions: NgbModalOptions): Observable<any> {
    let modalRef = this.modalService.open(TripUploaderComponent, modalOptions);
    modalRef.componentInstance.latlngs = this.latlngs;
    return from(modalRef.result).pipe(
      catchError(e => of(null))
    );
  }

  public select(route) {
    this.route.navigate(['/trips', `${route.entityID.id1.id}_${route.entityID.id2}`], { queryParams: { page: this.page } });
  }

  public remove(routeId) {
    this.isLoading = true;
    this.actionText = "Removing...";
    this.dataService.removeRoute(routeId).subscribe(e => {
      this.refreshPage();
    });
  }
}
